import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { query } from '@/api/looker/utils/query';
import { useLookerModelId } from '@/hooks/looker/use-looker-model-id';
import { useLookerSdk } from '@/hooks/useLookerSdk';

type Group = {
  value: string;
  label: string;
};

export type GroupsData = {
  groups: Group[];
};
export function useListGroupsData(): UseQueryResult<GroupsData> {
  const coreSDK = useLookerSdk();
  const model = useLookerModelId();

  return useQuery({
    queryKey: ['api/looker/list-groups', model],
    async queryFn(): Promise<GroupsData> {
      const groups = await query(coreSDK)
        .from<{
          'frontend_id_mapping.frontend_group_id': string;
          'frontend_id_mapping.frontend_group_id_raw': string;
        }>({
          model,
          view: 'frontend_id_mapping',
          fields: [
            'frontend_id_mapping.frontend_group_id',
            'frontend_id_mapping.frontend_group_id_raw',
          ],
          sorts: ['frontend_id_mapping.frontend_group_id asc'],
          filters: { 'frontend_id_mapping.frontend_group_id': '-NULL' },
        })
        .toMany<Group>((result) => ({
          label: result['frontend_id_mapping.frontend_group_id'],
          value: result['frontend_id_mapping.frontend_group_id_raw'],
        }));
      return {
        groups,
      };
    },
  });
}
